export default "__VITE_ASSET__d4fc7b9b__"